<ng-container *ngIf="projectTaskSign?.taskId">
  <div class="d-flex flex-column" style="gap: 16px;">
    <div class="box-default">
      <img src="assets/img/task-info-default.svg">
      <h4 class="text-muted">
        Esta sinalização está dentro de uma tarefa não concluída.
      </h4>
    </div>
    <div class="row-popover">
      <div class="d-flex">
        <app-sign-svg [sign]="projectTaskSign" [width]="40" [height]="40"></app-sign-svg>
        <div class="d-flex flex-column ml-3" style="width: 140px;">
          <span class="sign-code">{{projectTaskSign?.verticalCode}}</span>
          <span class="sign-name">{{projectTaskSign?.verticalCode |enumText: 'Signaling'}}</span>
        </div>
      </div>
      <div>
        <a [href]="url" class="btn btn-link btn-popup d-flex align-items-center p-0"
          target="_blank" style="height: 20px;">
          <span>
            VER ITEM
          </span>
          <i class="fas fa-angle-right ml-2 mr-0" style="font-size: 20px;"></i>
        </a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="projectTaskSign?.projectId">
  <div class="d-flex flex-column" style="gap: 16px;">
    <div class="box-default">
      <img src="assets/img/project-info-default.svg">
      <h4 >
        Esta sinalização foi projetada, mas não implantada.
      </h4>
    </div>
    <div class="row-popover">
      <div class="d-flex">
        <app-sign-svg [sign]="projectTaskSign" [width]="40" [height]="40"></app-sign-svg>
        <div class="d-flex flex-column ml-3" style="width: 140px;">
          <span class="sign-code">{{projectTaskSign?.verticalCode}}</span>
          <span class="sign-name">{{projectTaskSign?.verticalCode |enumText: 'Signaling'}}</span>
        </div>
      </div>
      <div>
        <a [href]="url" class="btn btn-link btn-popup d-flex align-items-center justify-content-center p-2"
          target="_blank" style="height: 30px; width: 125px;">
          <span>
            VER ITEM
          </span>
          <i class="fas fa-angle-right ml-2 mr-0" style="font-size: 20px;"></i>
        </a>
      </div>
    </div>
  </div>
</ng-container>
